import DeleteOutlineIcon from '@mui/icons-material/DeleteOutlined';
import ListAltOutlined from '@mui/icons-material/ListAltOutlined';
import { Box } from '@mui/material';
import type { MouseEventHandler } from 'react';
import { useNavigate } from 'react-router';
import Button from '@/components/Buttons/Button';
import {
  FWDCURVE_CATALOG_PATH,
  SHOW_SELECTED_URL_PARAM,
  SPOT_CATALOG_PATH
} from '@/constants/constants';
import { SELECTOR_MODES } from '@/features/SymbolSelector/store/symbolSelector.slice';
import { useAppDispatch, useAppSelector } from '@/hooks/redux-hooks';
import { closeDrawer } from '@/slices/drawerSlice';

const rootSx = { display: 'flex', gap: 2 };
const clearBtnSx = {
  fontSize: 14,
  width: 123,
  height: 30,
  backgroundColor: 'gx.actionBarButtonTile'
};
const viewBtnSx = {
  fontSize: 14,
  width: 144,
  height: 30,
  backgroundColor: 'gx.actionBarButtonTile'
};

const ButtonGroup = ({ onClearAll }: { onClearAll: MouseEventHandler<HTMLButtonElement> }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const selectorMode = useAppSelector(state => state.symbolSelector.selectorMode);

  const handleViewInCatalog = () => {
    const catalogPath =
      selectorMode === SELECTOR_MODES.FORWARD_CURVE ? FWDCURVE_CATALOG_PATH : SPOT_CATALOG_PATH;
    navigate(`/catalog/${catalogPath}?${SHOW_SELECTED_URL_PARAM}=true`);
    dispatch(closeDrawer());
  };

  return (
    <Box sx={rootSx}>
      <Button
        onClick={onClearAll}
        startIcon={<DeleteOutlineIcon />}
        sx={clearBtnSx}
      >
        Clear All
      </Button>
      <Button
        onClick={handleViewInCatalog}
        startIcon={<ListAltOutlined />}
        sx={viewBtnSx}
      >
        View in catalog
      </Button>
    </Box>
  );
};

export default ButtonGroup;
